module.exports = __webpack_public_path__ + "static/img/institution01.013e2e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/institution01.png
// module id = aVXv
// module chunks = 1